<!--
 * @Description: 卡管理
 * @Author: Zhang Xin (1483812724@qq.com)
 * @Date: 2022-12-26 16:53:42
 * @LastEditors: Wang Xiaowu (wangxiaowu@example.com)
 * @LastEditTime: 2023-02-03 11:17:34
 -->
<!-- 卡管理页面 -->
<template>
 <div class="big-box">
   <div class="cardmanagement">
    <div><h2>卡管理在线查询</h2></div>
    <div class="input-find">
      <el-input v-model="input" placeholder="请输入ICCID或者IMEI查询" style="width:300px;height:42px"></el-input>
      <el-button class="" @click="handleGetinfo" :loading='loading' type="primary" icon="el-icon-search">查询</el-button>
    </div>
    <div class="table-box" v-if="mmsgs">查询结果</div>
    <div v-if="type" class="table-boxs">
      iccid/imei为空,请重新输入
    </div>
    <div v-if="msg" class="table-boxs">
        未找到"{{input1}}"相关数据,请检查ICCID/IMEI
    </div>
    <div class="table-box1" v-if="mmsg">
      <tr>
        <td>ID</td>
        <td>{{this.data.id==null ? '无':this.data.id }}</td>
      </tr>
      <tr>
        <td>计费日期</td>
        <td>{{this.data.sendGoodsDate==null ? '无' : this.data.sendGoodsDate}}</td>
      </tr>
      <tr>
        <td>终止日期</td>
        <td>{{this.data.stopDate==null ? '无信息' : this.data.stopDate}}</td>
      </tr>
      <tr>
        <td>卡名称/类型</td>
        <td>{{this.data.goodsName ==null ? '无' : this.data.goodsName }}</td>
      </tr>
      <tr>
        <td>卡供货商</td>
        <td>{{this.data.supplier==null ? '无' : this.data.supplier }}</td>
      </tr>
      <tr>
        <td>ICCID</td>
        <td>{{this.data.iccid ==null ? '无' : this.data.iccid}}</td>
      </tr>
      <tr>
        <td>IMEI</td>
        <td>{{this.data.imei==null ? '无' : this.data.imei }}</td>
      </tr>
      <!-- <tr>
        <td>数量小计</td>
        <td>{{ this.datas[0].numSubtotal }}</td>
      </tr>
      <tr>
        <td>收件人</td>
        <td>{{ this.datas[0].addressee }}</td>
      </tr> -->
      <tr>
        <td>状态</td>
        <td v-if="zt==true" style="color:#1cdd1c">{{ isUsed }}</td>
        <td v-if="zt==false" style="color:red">{{ isUsed }}</td>
      </tr>
       <tr v-if="zzx">
        <td>注册状态</td>
        <td>{{isRegist }}</td>
      </tr>
       <tr v-if="zzx">
        <td>安装状态</td>
        <td>{{ isInstall }}</td>
      </tr>
         <tr v-if="zzx">
        <td>在线状态</td>
        <td>{{ isOnline}}</td>
      </tr>
      <!-- <tr>
        <td>备注</td>
        <td>{{ this.datas[0].remaker }}</td>
      </tr>
      <tr>
        <td>用途</td>
        <td>{{ this.datas[0].purpose }}</td>
      </tr> -->
      <tr v-if="zzx">
        <td>安装位置</td>
        <td style="line-height:normal;">{{ this.data.installLocation==null ? '无' : this.data.installLocation }}</td>
      </tr>
      <tr v-if="zzx">
        <td>设备类型名称</td>
        <td>{{ this.data.typeName==null ? '无' : this.data.typeName }}</td>
      </tr>
      <tr v-if="zzx">
        <td>设备种类名称</td>
        <td>{{ this.data.tname==null ? '无' : this.data.tname }}</td>
      </tr>
    </div>
  </div>
 </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      loading:false,
      zt:true,
      input: "",
      input1:'',
      type: false,
      msg: false,
      data: [],
      mmsg: false,
      mmsgs:true,
      isOnline:'',
      isInstall:'',
      isRegist:'',
      isUsed:'',
      zzx:false
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // this.handleGetinfo();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  // 方法集合
  methods: {
    //获取数据
    handleGetinfo() {
      this.loading=true
      
        this.request
        .get("/front/device/card/findImeIcc", {
          iccid: this.input, 
        })
        .then((res) => {
          console.log("lufei", res);
        if(res.code){
        this.data = res.data;
        this.loading=false
        if (this.handleFang(this.input) == 0) {
        this.type = true;
        this.msg = false;
        this.mmsg = false;
        this.mmsgs = true;
  
      } 
       if (this.handleFang(this.input) == 1) {
        this.msg = true;
        this.type = false;
        this.mmsg = false;
        this.input1=this.input
        this.mmsgs = true;
      } 
       if (this.handleFang(this.input) == 3) {
          if(this.data.isUsed==1){
          this.isUsed='使用'
          this.zt=true
        }else{
          this.isUsed='已到期'
          this.zt=false
        }
          this.mmsg = true;
        this.type = false;
        this.msg = false;
        this.zzx=false
        this.mmsgs = true;
        
       
              // console.log("sd", this.datas[0].isOnline);
      } 
       if (this.handleFang(this.input) == 4) {
        //   console.log("sd", this.datas);
        
           if(this.data.isOnline){
          this.isOnline='在线'
        }else{
          this.isOnline='离线'
        }
         if(this.data.isInstall){
          this.isInstall='已安装'
        }else{
          this.isInstall='未安装'
        }
         if(this.data.isRegist){
          this.isRegist='已注册'
        }else{
          this.isRegist='未注册'
        }
        if(this.data.isUsed==1){
          this.zt=true
          this.isUsed='使用'
          
        }else{
          this.zt=false
          this.isUsed='已到期'
          
        }
        this.mmsg = true;
        this.type = false;
        this.msg = false;
        this.zzx=true
        this.mmsgs = true;
      }
        }
        });
    },
    //封装方法
    handleFang(msg) {
     
      if (msg == "") {
        return 0;
      } 
      if (this.data==null) {
        return 1;
      }
      if (this.data.iccid == msg) {
        return 3;
      } 
       if (this.data.imei == msg) {
        return 4;
      }
     
    },
    
  },
};
</script>

<style lang='scss' scoped>
//@import url(); 引入公共css类
.big-box{
  height: 100%;
  min-width: 1200px;
  overflow: scroll;
  .cardmanagement {
  padding-top: 15px;
  margin-bottom: 100px;
  box-sizing: border-box;
  text-align: center;
  position: relative;
  .input-find {
    margin-top: 30px;
    position: relative;
    /deep/.el-input__inner{
      border-radius: 0px;
      height: 42px;
      border: 1px solid #000;
      
    }
    /deep/.el-button{
      height: 42px;
      border-radius: 0px;
    }
    input {
      width: 300px;
      height: 40px;
      color: #000;
      border: 1px solid rgb(128, 124, 124);
      padding-left: 15px;
      
    }
    .find-button {
      position: absolute;
      top: 0;
      left: 59%;
      width: 80px;
      height: 40px;
      background-color: rgb(41, 112, 41);
      text-align: center;
      line-height: 40px;
      border: 1px solid rgb(41, 112, 41);
      color: #fff;
      cursor: pointer;
     
    }
  }
  .table-box {
    width: 600px;
    height: 40px;
    background-color: #939393;
    text-align: center;
    line-height: 40px;
    margin: 0 auto;
    font-size: 16px;
    font-weight: bold;
    margin-top: 50px;
    color: #fff;
  }
  .table-boxs{
    width: 598px;
    height: 200px;
    margin: 0 auto;
    line-height: 90px;
    color: red;
    font-size: 16px;
    border: 1px solid #758576;
  }
  .table-box1 {
    width: 600px;
    height: 600px;
    margin: 0 auto;
    td {
      border: 1px solid #666;
      width: 300px;
      height: 40px;
      line-height: 40px;
    }
  }
  .table-box1>tr>td:first-child{
    background-color: #f1ebe8;
    color: #000;
    font-weight: bold;
  }
}
}
</style>
